
import {
  ArrowLeftIcon,
  CornerUpRightIcon,
  CornerDownLeftIcon,
  ChevronLeftIcon,
  ShoppingBagIcon,
} from 'vue-feather-icons';
import IconCart from './IconCart.vue';
export default {
  components: {
    ArrowLeftIcon,
    CornerUpRightIcon,
    CornerDownLeftIcon,
    ChevronLeftIcon,
    ShoppingBagIcon,
    IconCart,
  },
  methods: {
    handleBackClick() {
      const isBrowser = typeof window !== 'undefined';
      const historyState =
        isBrowser && window.history ? window.history.state : null;
      const historyEntries = [];

      if (historyState) {
        ['back', 'current', 'forward'].forEach((key) => {
          const value = historyState[key];
          if (typeof value === 'string') {
            historyEntries.push(value);
          }
        });
      }

      const targets = ['pages/s/_code.vue', 'pages\\s\\_code.vue'];
      const cameFromSCode = historyEntries.some((entry) =>
        targets.some((target) => entry.includes(target))
      );

      if (
        cameFromSCode ||
        !isBrowser ||
        (window.history && window.history.length <= 1)
      ) {
        this.$router.push(this.localePath({ name: 'index' }));
        return;
      }

      this.$router.back();
    },
  },
};
